import { createApp } from 'vue';
import VueDOMPurifyHTML from 'vue-dompurify-html';
import SearchBox from './components/SearchBox.vue';

const MOUNT = '[data-hc-search]';
const OPEN_CHAT = '[data-hc-open-chat]';
const apps = new Map();
let documentListenersBound = false;

const mountSearchBox = element => {
  const { searchUrl, suggestUrl, locale, label, placeholder, size, strings } =
    element.dataset;
  const app = createApp(SearchBox, {
    id: element.id,
    action: searchUrl,
    suggestUrl,
    locale,
    label,
    placeholder,
    size,
    strings: JSON.parse(strings),
    initialQuery: element.querySelector('input[name="query"]').value,
  });
  app.use(VueDOMPurifyHTML);
  app.mount(element);
  apps.set(element, app);
};

const isSearchShortcut = event =>
  (event.metaKey || event.ctrlKey) &&
  !event.altKey &&
  !event.shiftKey &&
  event.key.toLowerCase() === 'k';

const onKeydown = event => {
  if (!isSearchShortcut(event)) return;
  const input = document.querySelector(`${MOUNT} input[name="query"]`);
  if (!input) return;
  event.preventDefault();
  input.focus();
  input.select();
};

const onClick = event => {
  if (event.target.closest(OPEN_CHAT)) window.$chatwoot.toggle('open');
};

const revealChat = () => {
  document.querySelectorAll(OPEN_CHAT).forEach(button => {
    button.hidden = false;
  });
};

export function initSearch() {
  apps.forEach((app, element) => {
    if (element.isConnected) return;
    app.unmount();
    apps.delete(element);
  });
  document.querySelectorAll(MOUNT).forEach(element => {
    if (!apps.has(element)) mountSearchBox(element);
  });

  if (window.$chatwoot?.hasLoaded) revealChat();
  if (documentListenersBound) return;
  documentListenersBound = true;
  document.addEventListener('keydown', onKeydown);
  document.addEventListener('click', onClick);
  window.addEventListener('chatwoot:ready', revealChat);
}
